import type { ApiKey, SaveStatus } from '../../_shared/domain/api-key.model';

/**
 * Redux state for the API keys admin index. The loaded rows, the load lifecycle
 * (`error` holds a human-readable banner/snackbar message), and two independent
 * write lifecycles: create (which also stashes the one-time raw secret to show
 * in the dialog) and revoke. Every field is serialisable.
 */
export interface ApiKeysState {
  rows: ApiKey[];
  loading: boolean;
  error: string | null;
  createStatus: SaveStatus;
  /** The raw secret returned once on create; shown in the dialog, then cleared. */
  createdKey: string | null;
  revokeStatus: SaveStatus;
}

export const initialState: ApiKeysState = {
  rows: [],
  loading: false,
  error: null,
  createStatus: 'idle',
  createdKey: null,
  revokeStatus: 'idle',
};
